import { mapState, mapActions, mapGetters } from 'vuex';

import { useDataLoading, usePagination, useSearch } from '@mixins/factories';

import ColoredStateBadge from '@components/coloredStateBadge';
import OuterLink from '@components/outerLink';

import JobsSync from '../../_components/jobsSync';

const dataLoadingOptions = { getterName: 'getJobs', contentName: 'jobs' };
const paginationOptions = { contentName: 'jobs' };
const searchOptions = {
  initialSearchDataStates: [
    'outerId', 'basketId', 'vendor', 'state', 'substate',
  ],
  customTypes: {
    state: 'number',
    substate: 'number',
  },
};

const jobsHeaders = Object.freeze([
  { text: 'Outer ID', value: 'outerId' },
  { text: 'Basket ID', value: 'basketId' },
  { text: 'Printing machine', value: 'printingMachine' },
  { text: 'State', value: 'state' },
  { text: 'Reason', value: 'reason' },
  { text: 'Last update', value: 'lastUpdate', width: '230px' },
  { text: '', value: 'actions', width: '5%' },
]);

export default {
  name: 'Jobs',
  mixins: [
    useDataLoading(dataLoadingOptions),
    usePagination(paginationOptions),
    useSearch(searchOptions),
  ],
  components: {
    ColoredStateBadge,
    OuterLink,
    JobsSync,
  },
  data() {
    return {
      jobsHeaders,
    };
  },
  computed: {
    ...mapState('jobs', ['jobs']),
    ...mapState('locations', ['suffix']),
    ...mapGetters('enums', ['jobStateEnum', 'jobSubStateEnum']),
    jobStateOptions() {
      return this.jobStateEnum.map(({ value, name: text }) => ({ value, text }));
    },
    jobSubStateOptions() {
      return this.jobSubStateEnum.map(({ value, name: text }) => ({ value, text }));
    },
    searchFieldsConfig() {
      return [
        {
          value: 'outerId', label: 'Outer ID', type: 'text', flex: 'lg3',
        },
        {
          value: 'basketId', label: 'Basket ID', type: 'text', flex: 'lg3',
        },
        {
          value: 'state',
          items: this.jobStateOptions,
          label: 'State',
          type: 'select',
          flex: 'lg3',
        },
        {
          value: 'substate',
          items: this.jobSubStateOptions,
          label: 'Substate',
          type: 'select',
          flex: 'lg3',
        },
      ];
    },
  },
  watch: {
    suffix() {
      this.$_refreshData();
      this.getLocations();
    },
  },
  methods: {
    ...mapActions('jobs', ['getJobs']),
    ...mapActions('locations', ['getLocations']),
  },
};
